import { c as _c } from "react-compiler-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
import useCrmObjectTypeListingFilterState from 'framework-listing-lib/internal/hooks/useCrmObjectTypeListingFilterState';
import { createZustandStoreContext } from 'framework-listing-lib/internal/store/zustand';
import { createExpandableObjectIdsStore } from '../store/expandableObjectIdsStore';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmObjectTypeListingContext = /*#__PURE__*/createContext(null);
const FilterContext = /*#__PURE__*/createContext(null);
const {
  ContextProvider: FilterStateStoreContext,
  useStore: useFiltersStateStore
} = createZustandStoreContext();
const {
  ContextProvider: ExpandableObjectIdsContext,
  useStore: useExpandableObjectIdsStore
} = createZustandStoreContext();
export default function CrmObjectTypeListingClientProvider(t0) {
  "use memo";

  const $ = _c(36);
  const {
    associationSpecs,
    calendarProps,
    children,
    emptyStateFilter,
    fetcher,
    folderProps,
    hiddenFilter: hiddenFilterProp,
    initialFilter,
    inlineEditProps,
    quickFilterProps,
    searchInputProps
  } = t0;
  const [uncontrolledFolderId, setUncontrolledFolderId] = useState(undefined);
  let t1;
  if ($[0] !== folderProps || $[1] !== uncontrolledFolderId) {
    t1 = folderProps !== null && folderProps !== void 0 && folderProps.onSetCurrentFolderId ? {
      onSetCurrentFolderId: folderProps.onSetCurrentFolderId,
      currentFolderId: folderProps.currentFolderId
    } : {
      onSetCurrentFolderId: setUncontrolledFolderId,
      currentFolderId: uncontrolledFolderId
    };
    $[0] = folderProps;
    $[1] = uncontrolledFolderId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    onSetCurrentFolderId,
    currentFolderId
  } = t1;
  let t2;
  if ($[3] !== calendarProps || $[4] !== currentFolderId || $[5] !== hiddenFilterProp || $[6] !== initialFilter) {
    t2 = {
      calendarProps,
      hiddenFilter: hiddenFilterProp,
      initialFilter,
      folderId: currentFolderId
    };
    $[3] = calendarProps;
    $[4] = currentFolderId;
    $[5] = hiddenFilterProp;
    $[6] = initialFilter;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    hiddenFilter,
    isFilterFromCustomView,
    filtersStateStore,
    filterGroups,
    quickFilters
  } = useCrmObjectTypeListingFilterState(t2);
  let t3;
  if ($[8] !== associationSpecs || $[9] !== calendarProps || $[10] !== currentFolderId || $[11] !== emptyStateFilter || $[12] !== fetcher || $[13] !== folderProps || $[14] !== hiddenFilter || $[15] !== initialFilter || $[16] !== inlineEditProps || $[17] !== isFilterFromCustomView || $[18] !== onSetCurrentFolderId || $[19] !== quickFilterProps || $[20] !== searchInputProps) {
    t3 = {
      associationSpecs,
      calendarProps,
      emptyStateFilter,
      fetcher,
      folderId: currentFolderId,
      folderProps,
      hiddenFilter,
      initialFilter,
      inlineEditProps,
      isFilterFromCustomView,
      onSetFolderId: onSetCurrentFolderId,
      quickFilterProps,
      searchInputProps
    };
    $[8] = associationSpecs;
    $[9] = calendarProps;
    $[10] = currentFolderId;
    $[11] = emptyStateFilter;
    $[12] = fetcher;
    $[13] = folderProps;
    $[14] = hiddenFilter;
    $[15] = initialFilter;
    $[16] = inlineEditProps;
    $[17] = isFilterFromCustomView;
    $[18] = onSetCurrentFolderId;
    $[19] = quickFilterProps;
    $[20] = searchInputProps;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  const value = t3;
  let t4;
  if ($[22] !== filterGroups || $[23] !== quickFilters) {
    t4 = {
      filterGroups,
      quickFilters
    };
    $[22] = filterGroups;
    $[23] = quickFilters;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  const computedFilterValue = t4;
  let t5;
  if ($[25] !== children) {
    t5 = /*#__PURE__*/_jsx(ExpandableObjectIdsContext, {
      initializeStore: _temp,
      children: children
    });
    $[25] = children;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== computedFilterValue || $[28] !== t5) {
    t6 = /*#__PURE__*/_jsx(FilterContext.Provider, {
      value: computedFilterValue,
      children: t5
    });
    $[27] = computedFilterValue;
    $[28] = t5;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  let t7;
  if ($[30] !== filtersStateStore || $[31] !== t6) {
    t7 = /*#__PURE__*/_jsx(FilterStateStoreContext, {
      store: filtersStateStore,
      children: t6
    });
    $[30] = filtersStateStore;
    $[31] = t6;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  let t8;
  if ($[33] !== t7 || $[34] !== value) {
    t8 = /*#__PURE__*/_jsx(CrmObjectTypeListingContext.Provider, {
      value: value,
      children: t7
    });
    $[33] = t7;
    $[34] = value;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  return t8;
}
function _temp() {
  return createExpandableObjectIdsStore();
}
export function useCrmObjectType() {
  "use memo";

  const context = useContext(CrmObjectTypeListingContext);
  if (context === null) {
    throw new Error("useCrmObjectType must be used within a CrmObjectTypeListingClientProvider");
  }
  return context;
}
export function useComputedFilters() {
  "use memo";

  const context = useContext(FilterContext);
  if (context === null) {
    throw new Error("useComputedFilters must be used within a CrmObjectTypeListingClientProvider");
  }
  return context;
}
export { useExpandableObjectIdsStore, useFiltersStateStore };